import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { PERMISSIONS } from "app/utils/permissions";

const FarmTypeList = Loadable(lazy(() => import("./FarmTypeList")));
const FarmTypeForm = Loadable(lazy(() => import("./FarmTypeForm")));

const farmTypeRoutes = [
  {
    path: "/FarmType/FarmTypeList",
    element: <FarmTypeList />,
    permission: PERMISSIONS.FarmTypes.Menu,
  },
  {
    path: "/FarmType/FarmTypeForm",
    element: <FarmTypeForm />,
  },
  {
    path: "/FarmType/FarmTypeForm/:farmTypeId",
    element: <FarmTypeForm />,
  },
];
export default farmTypeRoutes;
